module.exports = __webpack_public_path__ + "9a67a6a38a3ebfca4b142bd110b2f39c.png";